import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from './ui/Section';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito una computadora potente?',
    a: 'No, todo se hace en la nube desde tu navegador o celular.'
  }, {
    q: '¿Tengo que pagar suscripciones caras?',
    a: 'Puedes empezar 100% gratis con las herramientas que te enseñamos.'
  }, {
    q: '¿Funciona para cualquier nicho?',
    a: 'Sí, mientras haya gente buscando información o entretenimiento, el método Ghost funciona.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-brand-darker/50 border-y border-white/5" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <div className="text-center mb-12" data-id="element-35">
          <div className="inline-flex items-center justify-center p-3 bg-brand-purple/10 rounded-full mb-4 text-brand-purpleLight" data-id="element-36">
            <HelpCircle size={32} data-id="element-37" />
          </div>
          <h2 className="text-4xl font-bold mb-4" data-id="element-38">Preguntas Frecuentes</h2>
        </div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <div key={index} className="glass-card border-white/10 rounded-xl overflow-hidden" data-id="element-40">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-41">
                <span className="text-lg font-semibold text-white pr-8" data-id="element-42">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-brand-cyan shrink-0" data-id="element-43">
                  <ChevronDown size={24} data-id="element-44" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-45">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-46">
                    <div className="px-6 pb-5 text-brand-gray border-t border-white/5 pt-4" data-id="element-47">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}